import { CreateContactInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createContactMutationAtom = createMutationAtomFactory(
  'crm.contactCreate',
  (contact: CreateContactInput) => ({
    crmContactCreate: {
      __args: {
        input: contact,
      },
      id: true,
    },
  }),
);
